import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import Sidepanel from '@blocks/Sidepanel'
import { useConfigContext } from '@contexts/config'
import React, { useState } from 'react'
import PaymentPromo from './components/PaymentPromo'
import PayPal from './components/PayPal'
import Stripe from './components/Stripe'

export default function SalonPaymentSidepanel({ salon }: Props) {
    const { support } = useConfigContext()
    const [promo, setPromo] = useState<Customer.States.Promo>()

    return (
        <Sidepanel heading={`Fee: €${promo?.fee || salon.state.fee}${promo?.discount ? ` (-${promo.discount}%)` : ""}`} maxWidth="600px">
            <Grid>
                <EmphasizedContent>
                    <Grid gap="20px">
                        <h4>Card</h4>
                        <Stripe salon={salon} promo={promo} />
                        <hr />
                        <PayPal salon={salon} promo={promo} />
                    </Grid>
                </EmphasizedContent>
                <PaymentPromo salon={salon} onChange={setPromo} />
                <Grid gap="5px">
                    <b>Note</b>
                    <small>Your status will be changed automatically after succesfull transaction. If for some reason you are not able to make payment automatically on the web site, please, pay manually to <a href={`mailto:${support}`}>{support}</a> Pay Pal and we are going to change your status.</small>
                </Grid>
			</Grid>
        </Sidepanel>
    )
}

// TYPES
interface Props  {
    salon: Customer.Models.Salon.Stateful
}